export type TOidcProviderType = 'unknown' | 'google';

export interface IAuthentication {
  accessToken: string;
  isAuthenticated: boolean;
  oidcAccessToken: string;
  oidcProviderType: TOidcProviderType;
  isGoogleSignedIn: boolean;
  authenticationInProgress: boolean;
  login: string;
  password: string;
  workflowToken: string;
}

export const emptyAuthentication: IAuthentication = {
  accessToken: '',
  isAuthenticated: false,
  oidcAccessToken: '',
  oidcProviderType: 'unknown',
  isGoogleSignedIn: false,
  authenticationInProgress: false,
  login: '',
  password: '',
  workflowToken: ''
};
